/**
 * @ngdoc directive
 * @name gallery
 *
 * @description
 * Gallery component
 */
module
    .directive('gallery', function ($compile, $document, scrolllocker) {
        'use strict';
        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@?',
                pictures: '=content',
                downloadable: '@?',
                nid: '@?',
                theme: '=?',
                alternativeStyle: '@?'
            },
            controller: ['$scope', '$filter', 'tools', function ($scope, $filter, tools) {
                $scope.labelmore = $filter('translate')('gallery.seeAll');

                $scope.seeMoreLabel = function (pictures) {
                    return tools.replace($filter('translate')('gallery.seePictures'), {number: pictures.length});
                };

            }],
            link: function ($scope) {
                $scope.current = 0;

                // Drawer element used to display predictions
                var viewerElement = angular.element('<gallery-viewer></gallery-viewer>');
                var body = angular.element($document[0].body);
                var $viewer;

                $scope.open = false;
                viewerElement.attr({
                    open: 'open',
                    pictures: 'pictures',
                    current: 'current',
                    downloadable: $scope.downloadable
                });

                $viewer = $compile(viewerElement)($scope);
                body.append($viewer);

                $scope.$on('$destroy', function () {
                    $viewer.remove();
                });

                $scope.$watchCollection('open', function (newValue) {
                    if (!!newValue) {
                        scrolllocker.lock();
                    } else {
                        scrolllocker.unlock();
                    }
                });
                $scope.openViewer = function (idx) {
                    $scope.current = idx;
                    $scope.open = true;
                };
            },
            template:
                    '<div class="aqua-gallery" ng-style="{\'background-color\':theme.color_background}">' +
                    '   <a ng-attr-name="{{nid}}"></a>' +
                    '   <div ng-if="!alternativeStyle" class="grid-main">' +
                    '   <h2 class="grid grid-center" ng-style="{\'color\':theme.color_title}"><span class="aqua-gallery--title">{{label}}</span></h2>' +
                    '   <div class="aqua-gallery--pictures grid-12 grid grid-center">' +
                    /* pictures container*/
                    '       <div class="aqua-gallery--container grid-10 grid-12-s grid">' +
                    /* first column */
                    '           <div class="grid-7 grid-12-s grid grid-v">' +
                    /* first row */
                    '               <div class="aqua-gallery--cell aqua-gallery--cell-large">' +
                    '                   <div class="aqua-gallery--picture" ng-click="openViewer(0)">' +
                    '                       <picture>' +
                    '                           <source media="(min-width: 480px)" srcset="{{ pictures[0].styles.w446h298 }}" title="{{pictures[0].alt}}" class="gallery-image">' +
                    '                           <source media="(max-width: 479px)" srcset="{{ pictures[0].styles.w442h148 }}" title="{{pictures[0].alt}}" class="gallery-image">' +
                    '                           <img src="{{ pictures[0].src }}" title="{{pictures[0].alt}}" class="gallery-image" loading="lazy">' +
                    '                       </picture>' +
                    '                   </div>' +
                    '               </div>' +
                    /* second row*/
                    '               <div class="aqua-gallery--row">' +
                    '                   <div class="aqua-gallery--cell grid-6 grid-12-s">' +
                    '                       <div class="aqua-gallery--picture" ng-click="openViewer(1)" >' +
                    '                           <picture>' +
                    '                               <source media="(min-width: 480px)" srcset="{{ pictures[1].styles.w222h148 }}" title="{{ pictures[1].alt }}" class="gallery-image">' +
                    '                               <source media="(max-width: 479px)" srcset="{{ pictures[1].styles.w442h148 }}" title="{{ pictures[1].alt }}" class="gallery-image">' +
                    '                               <img src="{{ pictures[1].src }}" title="{{ pictures[1].alt }}" class="gallery-image" loading="lazy">' +
                    '                           </picture>' +
                    '                       </div>' +
                    '                   </div>' +
                    '                   <div class="aqua-gallery--cell grid-6 grid-12-s">' +
                    '                       <div class="aqua-gallery--picture" ng-click="openViewer(2)">' +
                    '                           <picture>' +
                    '                               <source media="(min-width: 480px)" srcset="{{ pictures[2].styles.w222h148 }}" title="{{ pictures[2].alt }}" class="gallery-image">' +
                    '                               <source media="(max-width: 479px)" srcset="{{ pictures[2].styles.w442h148 }}" title="{{ pictures[2].alt }}" class="gallery-image">' +
                    '                               <img src="{{ pictures[2].src }}" title="{{ pictures[2].alt }}" class="gallery-image" loading="lazy">' +
                    '                           </picture>' +
                    '                       </div>' +
                    '                   </div>' +
                    '               </div>' +
                    '           </div>' +
                    /* second column */
                    '        <div class="aqua-gallery--cell grid-5 grid-12-s">' +
                    '           <picture>' +
                    '               <source media="(min-width: 961px)" srcset="{{ pictures[3].styles.w318h448 }}" title="{{ pictures[3].alt }}" class="aqua-gallery--picture">' +
                    '               <source media="(max-width: 479px)" srcset="{{ pictures[3].styles.w442h148 }}" title="{{ pictures[3].alt }}" class="aqua-gallery--picture">' +
                    '               <img src="{{ pictures[3].src }}" title="{{ pictures[3].alt }}" class="aqua-gallery--picture" loading="lazy">' +
                    '           </picture>' +
                    '        </div>' +
                    '      </div>' +
                    '      <p class="aqua-gallery--more grid-10 grid-12-s"><button class="aqua-gallery--more--link" ng-click="openViewer(0)" ng-style="{\'color\':theme.color_link}">{{labelmore}}</button></p>' +
                    '    </div>' +

                    '  </div>' +

                    /* If alternative styling (like on B2C) */
                    '<div ng-if="alternativeStyle" class="aqua-gallery--pictures">' +
                    '  <div class="grid">' +
                    '    <div class="grid-12-s aqua-gallery--cell" ng-class="($index === 0 || $index === 1) ? \'aqua-gallery--cell-landscape grid-6\' : \'grid-4\'" ng-repeat="picture in pictures | limitTo:5">' +
                    '       <div class="aqua-gallery--picture" ng-click="openViewer($index)">' +
                    '           <picture ng-if="$index <= 1">' +
                    '               <source media="(min-width: 480px)" srcset="{{ pictures[0].styles.w315h240 }}" title="{{picture.alt}}">'+
                    '               <source media="(max-width: 479px)" srcset="{{ pictures[0].styles.w442h148 }}" title="{{picture.alt}}">'+
                    '               <img src="{{ picture.src }}" title="{{picture.alt}}" loading="lazy">'+
                    '           </picture>'+
                    '           <picture ng-if="$index > 1">' +
                    '               <source media="(min-width: 480px)" srcset="{{ picture.styles.w207h150 }}" title="{{picture.alt}}">'+
                    '               <source media="(max-width: 479px)" srcset="{{ picture.styles.w442h148 }}" title="{{picture.alt}}">'+
                    '               <img src="{{ picture.src }}" title="{{picture.alt}}" loading="lazy">'+
                    '           </picture>'+
                    '       </div>' +
                    '      <div ng-if="$last" class="aqua-gallery--picture-more grid grid-center grid-middle" ng-click="openViewer($index)">{{ seeMoreLabel(pictures) }}</div>' +
                    '    </div>' +
                    '  </div>' +
                    '</div>'
        };
    })
    .directive('galleryViewer', function () {
        'use strict';
        return {
            restrict: 'E',
            scope: {
                open: '=',
                current: '=',
                pictures: '=',
                downloadable: '@'
            },
            link: function ($scope) {
                $scope.close = function () {
                    $scope.open = false;
                };
            },
            template:
                    '<div class="aqua-viewer grid grid-v grid-center grid-nw" ng-if="open" ng-swipe-left="next()" ng-swipe-right="prev()">' +
                    '  <button class="aqua-viewer--close" ng-click="close()" title="{{\'gallery.close\' | translate}}"><span class="is-sr-only">{{\'gallery.close\' | translate}}</span></button>' +
                    '  <diaporama diapos="pictures" downloadable="{{downloadable}}" type="viewer" current="current"></diaporama>' +
                    '</div>'
        };
    });
